import * as React from 'react';
export const heartFilledSvg = React.forwardRef(function heartFilledSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.756 8.746A4.23 4.23 0 0 0 16 5.748a4.231 4.231 0 0 0-1.244-3.005A4.234 4.234 0 0 0 11.75 1.5a4.234 4.234 0 0 0-3 1.243L8 3.5l-.75-.757a4.234 4.234 0 0 0-3-1.243 4.242 4.242 0 0 0-3.006 7.246l6.049 6.047a.997.997 0 0 0 1.414 0l6.05-6.047Z',
    }),
  );
});
heartFilledSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var heartFilled = {
  category: 'icon',
  colorable: true,
  name: 'heartFilled',
  svg: heartFilledSvg,
};
